import React from 'react'
import ReactDOM from 'react-dom/client'
import { IonApp, setupIonicReact } from '@ionic/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'

// Core CSS required for Ionic components to work properly
import '@ionic/react/css/core.css'

// Basic CSS for apps built with Ionic
import '@ionic/react/css/normalize.css'
import '@ionic/react/css/structure.css'
import '@ionic/react/css/typography.css'

// Optional CSS utils that can be commented out
import '@ionic/react/css/padding.css'
import '@ionic/react/css/float-elements.css'
import '@ionic/react/css/text-alignment.css'
import '@ionic/react/css/text-transformation.css'
import '@ionic/react/css/flex-utils.css'
import '@ionic/react/css/display.css'

// Tailwind CSS
import './index.css'

// Check version and clear old data if needed
import { checkAndClearOldData } from './utils/versionManager'

// Initialize i18n
import './i18n'

// Initialize Ionic first
setupIonicReact({
  mode: 'ios' // Use iOS mode for consistent design across platforms
})

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  },
})

// Clear old data asynchronously but don't block app startup
const initializeApp = async () => {
  try {
    await checkAndClearOldData()
    console.log('Version check completed successfully')
  } catch (error) {
    console.error('Version check failed, but continuing with app startup:', error)
  }
}

// Start the initialization but don't wait for it
initializeApp()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <IonApp>
        <App />
      </IonApp>
    </QueryClientProvider>
  </ErrorBoundary>
) 